import { Head, useForm } from "@inertiajs/react";
import { SubmitEvent } from "react";
import {
  ManagerBlogFormData,
  ManagerBlogsFormProps,
} from "@/types/manager_blogs";
import BlogForm from "./_form";

export default function EditBlog({
  blog,
  paths,
  limits,
  errors,
}: ManagerBlogsFormProps) {
  const { data, setData, patch, processing } = useForm<ManagerBlogFormData>({
    blog,
  });

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault();
    patch(paths.submit);
  };

  return (
    <div className="flex">
      <Head title="Edit Post" />
      <div className="grow">
        <div style={{ padding: "20px", maxWidth: "1100px", margin: "0 auto" }}>
          <BlogForm
            data={data}
            setData={setData}
            onSubmit={handleSubmit}
            processing={processing}
            errors={errors}
            paths={paths}
            limits={limits}
            title="Edit Post"
            submitLabel="Save Post"
          />
        </div>
      </div>
    </div>
  );
}
